var convert = require('./convert'),
    func = convert('difference', require('../difference'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp/difference.js
// module id = 617
// module chunks = 0